import * as Yup from 'yup';

/**
 * 行李寄存
 */
export interface LuggageInfo {
  /**
   * 寄存件数
   */
  number: string;
  /**
   * 行李牌号
   */
  luggage_code: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 寄存状态 1寄存 2已领取
   */
  luggage_status?: number;
}

/**
 * 行李寄存表单默认值
 */
export const defaultLuggageInfo: LuggageInfo = {
  number: '',
  luggage_code: '',
  remark: '',
};

/**
 * 行李寄存编辑表单默认值
 */
export const defaultLuggageEditInfo: LuggageInfo = {
  number: '',
  luggage_code: '',
  remark: '',
  luggage_status: null,
};

/**
 * 行李寄存表单校验
 */
export const luggageSchema = Yup.object().shape(
  {
    number: Yup.string().required('请输入寄存件数').matches(/^[1-9]\d*$/, '请输入正确的寄存件数').max(5, '寄存件数不能大于99999'),
    luggage_code: Yup.string().ensure().required('请输入行李牌号'),
  }
);